import { Box, Button, Flex, Input, Text, useClipboard } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { IoClose, IoLogoFacebook, IoLogoWhatsapp } from "react-icons/io5";
import { MdContentCopy } from "react-icons/md";

interface SharePopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SharePopup({ isOpen, onClose }: SharePopupProps) {
  const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState("");
  const { hasCopied, onCopy } = useClipboard(currentUrl);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
    }
  }, []);

  const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`;
  const whatsAppURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(
    currentUrl
  )}`;

  const handleFacebookShare = () => {
    if (typeof window !== "undefined") {
      window.open(facebookURL, `_blank`);
    }
  };

  const handleWhatsAppShare = () => {
    if (typeof window !== "undefined") {
      window.open(whatsAppURL, `_blank`);
    }
  };

  if (!isOpen) return null;

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      bg="rgba(0, 0, 0, 0.5)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex="9999"
    >
      <Box
        bg="white"
        borderRadius="md"
        p={6}
        maxWidth="400px"
        width="90%"
        position="relative"
      >
        <Button
          position="absolute"
          top={2}
          right={2}
          onClick={onClose}
          variant="ghost"
          size="sm"
        >
          <IoClose />
        </Button>

        <Text fontSize="lg" fontWeight="bold" mb={4}>
          Share this page
        </Text>

        <Flex gap={3} mb={4}>
          <Button
            leftIcon={<IoLogoFacebook />}
            colorScheme="facebook"
            onClick={handleFacebookShare}
            flex={1}
          >
            Facebook
          </Button>
          <Button
            leftIcon={<IoLogoWhatsapp />}
            colorScheme="whatsapp"
            bg="#25D366"
            _hover={{ bg: "#128C7E" }}
            onClick={handleWhatsAppShare}
            flex={1}
          >
            WhatsApp
          </Button>
        </Flex>

        <Flex gap={2}>
          <Input
            value={currentUrl}
            readOnly
            placeholder={currentUrl}
            flex={1}
          />
          <Button
            leftIcon={<MdContentCopy />}
            onClick={onCopy}
            colorScheme={hasCopied ? "green" : "gray"}
          >
            {hasCopied ? "Copied!" : "Copy"}
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}
